import { ScoreType } from '@/modules/schedule/store/models';

export const ScoreTypeOptions = [
          {value: ScoreType.NoScore, text: 'Brak wyniku'},
          {value: ScoreType.Classic, text: 'Klasyczny'},
          {value: ScoreType.Overtime, text: 'Dogrywka'},
          {value: ScoreType.Penalties, text: 'Rzuty karne'},
          {value: ScoreType.Walkover, text: 'Walkower'},
        ];
